var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.56 32.2103V45.4626L36.8953 53.973L22.2247 45.4626V28.4418L36.9012 19.9195L48.1713 26.4655L49.8745 25.4804L36.9012 17.9492L20.5273 27.4507V46.4477L36.9012 55.9492L53.2751 46.4477V31.2252L51.56 32.2103Z",
    fill: "url(#paint0_linear_64_12443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7909 45.4748H30.3398V37.2018H38.5179C39.2894 37.1959 40.0312 36.8814 40.5772 36.3235C41.1232 35.7716 41.4259 35.0238 41.4318 34.2463C41.4378 33.8606 41.3606 33.4808 41.2122 33.1247C41.0639 32.7686 40.8443 32.4481 40.5713 32.1811C40.3042 31.9081 39.9838 31.6885 39.6336 31.5401C39.2835 31.3917 38.9036 31.3146 38.5179 31.3205H30.3398V28.8042H38.5238C39.9541 28.8101 41.3309 29.3917 42.3398 30.4066C43.3547 31.4273 43.9244 32.8042 43.9363 34.2463C43.9422 35.3502 43.6099 36.4244 42.9808 37.3265C42.3992 38.187 41.5802 38.8635 40.6247 39.2671C39.6752 39.5698 38.69 39.7181 37.6989 39.7122H32.7909V45.4748Z",
    fill: "url(#paint1_linear_64_12443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8768 45.2665H41.0163L38.8086 41.3971C39.681 41.3437 40.5415 41.1656 41.3665 40.8689L43.8768 45.2665Z",
    fill: "url(#paint2_linear_64_12443)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8496 29.4571L51.541 30.4007L53.2324 29.4571V27.4571L51.541 26.4719L49.8496 27.4571V29.4571Z",
    fill: "url(#paint3_linear_64_12443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_12443",
    x1: 54.2679,
    y1: 30.0433,
    x2: 19.5003,
    y2: 43.8728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C200FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4897,
    stopColor: "#3772FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4898,
    stopColor: "#3773FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_12443",
    x1: 53.6009,
    y1: 28.3758,
    x2: 18.8334,
    y2: 42.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C200FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4897,
    stopColor: "#3772FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4898,
    stopColor: "#3773FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_12443",
    x1: 57.0629,
    y1: 37.0792,
    x2: 22.2954,
    y2: 50.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C200FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4897,
    stopColor: "#3772FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4898,
    stopColor: "#3773FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_64_12443",
    x1: 53.3414,
    y1: 27.7244,
    x2: 18.574,
    y2: 41.5539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C200FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4897,
    stopColor: "#3772FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4898,
    stopColor: "#3773FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC4BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRd);
export default __webpack_public_path__ + "static/media/rd.5f19802faef9a4e4163a489133ee1b72.svg";
export { ForwardRef as ReactComponent };